<app-superadmin-navbar></app-superadmin-navbar>
<div class="hostings-list-container">
	<h1>Modificar o eliminar Alojamientos</h1>
	<div *ngIf="isLoading">Cargando alojamientos...</div>
	<div *ngIf="errorMsg" class="error">{{ errorMsg }}</div>
	<div class="hostings-cards" *ngIf="!isLoading && hostings.length">
		<div class="hosting-card" *ngFor="let hosting of hostings">
			<img *ngIf="hosting.images && hosting.images.length" [src]="hosting.images[0]" alt="Imagen alojamiento" class="hosting-img" />
			<div class="hosting-info">
				<h3>{{ hosting.name }}</h3>
				<p><b>Tipo:</b> {{ hosting.type }}</p>
				<p><b>Ciudad:</b> {{ hosting.location?.city }}</p>
				<p><b>Teléfono:</b> {{ hosting.phone }}</p>
				<p><b>Email:</b> {{ hosting.email }}</p>
				<button [routerLink]="['/edit-hosting', hosting.id]">Editar</button>
				<button (click)="deleteHosting(hosting.id)">Eliminar</button>
			</div>
		</div>
	</div>
	<div *ngIf="!isLoading && !hostings.length">No hay alojamientos registrados.</div>
</div>
